<template>
    <!-- <v-dialog fullscreen style="position: relative; z-index: 999999999"> -->
        <v-card id="pass" style="width: 100vw !important; height: 100vh !important" flat color="white">

            <!--Title-->
			<!-- <div class="grey darken-3 white--text noprint">
				Location QR CODE {{ form.organisation.organisationName}}
			</div> -->

			<!--
			Printable QR Code
			  Renders a printable poster containing company information and the QR code
			-->
			<div class="d-flex flex-column align-center justify-center" v-if="JSON.stringify(form) !== '{}'">
                <v-card height=100% style="width: 100% !important" flat color="grey lighten-1" rounded=0 class=" align-center">
				    <!--Company logo-->
				    <v-img v-if="$vuetify.breakpoint.mdAndUp" :src="require('@/assets/tfw_logo_light.png')" contain width="100%" max-height="108" class="mt-6 mb-6 mx-auto"/>
				    <v-img v-else-if="$vuetify.breakpoint.smAndDown" :src="require('@/assets/tfw_logo_light.png')" contain width="100%" max-height="68" class="mt-6 mb-6 mx-auto"/>
                </v-card>

				<!--Instruction-->
				<p class="text-h3 primary--text text-center font-weight-bold py-4" style="width: 100%">Visitor Pass </p>
                

				<!--Site name-->
                <v-row>
                    <v-col cols="12">
                        <p class="text-h6 text-start my-1 mt-4 ma-0 font-weight-bold">SITE: <span class="text-h6 darkgrey--text">{{ form.site.siteName }}</span></p>
                        <!-- <p class="text-h6 my-1 ma-0 font-weight-bold" v-if="form.project.projectName">PROJECT: <span class="text-h6 darkgrey--text">{{ form.project.projectName }}</span></p> -->
                        <p class="text-h6 text-start mt-1 font-weight-bold">REASON FOR VISIT: <span class="text-h6 darkgrey--text">{{ form.passName }}</span></p>

                        <!--Site Validity-->
                        <p class="text-h6 text-start mb-0 success--text">VALID FROM: <span class="darkgrey--text">{{ formattedStartDate }} </span></p>
                        <p v-if="formattedEndDate !== formattedStartDate" class="text-h6 test-start mt-0 error--text">EXPIRES AFTER: <span class="darkgrey--text">{{ formattedEndDate }}</span></p>
                        <div v-if="JSON.stringify(form.users) !== '[]'" class="font-weight-bold text-start text-h5">Persons Listed for Site Access Permission</div>
                        <div v-if="JSON.stringify(form.users) !== '[]'" style="width: 70%" class="pl-3">
                            <div v-for="user in form.users" :key="user">
                                <v-row class="d-flex justify-center">
                                    <!-- <v-col cols="1" class="px-0 mx-0"> -->
                                        <div class="grey--text font-weight-bold text--darken-2">{{ getUserDetails(user, 'userName') }} 
                                    <!-- </v-col>
                                    <v-col cols="1" class="px-0 mx-0"> -->
                                        <span class="body-1 grey--text text-darken-1"> {{ form.organisation.organisationName }} </span>
                                    <!-- </v-col>
                                    <v-col cols="1" class="px-0 mx-0"> -->
                                        <span class="body-1 grey--text text-capitalize text-darken-1">  {{ getUserDetails(user, 'userType') }} </span></div>
                                    <!-- </v-col> -->
                                </v-row>
                            </div>
                        </div>
                    </v-col>
                </v-row>

				<!--Vindico branding-->
                <div class="justify-center">
                    <div class="px-2 pt-6"> 
                        <v-img :src="require('@/assets/vlogo.png')" width="128"/>
                    </div>
                    <p class="mt-1 grey--text px-2">Created by Vindico</p>
                </div>
			</div>

			<!-- <v-divider/> -->

			
			<v-card-actions v-if="$vuetify.breakpoint.mdAndUp" class="text-right noprint">
				<v-spacer/>
				<v-btn color="grey lighten-1" @click="closePass()">Close</v-btn>
				<v-btn color="black white--text" @click="exportPass()">Print / Save</v-btn>
			</v-card-actions>
			<v-card-actions v-else-if="$vuetify.breakpoint.smAndDown" class="text-right justify-center noprint">
				<v-btn color="grey lighten-1" @click="closePass()">Close</v-btn>
				<v-btn color="black white--text" @click="exportPass()">Print / Save</v-btn>
			</v-card-actions>
        </v-card>
    <!-- </v-dialog> -->
</template>


<script>
import {  mapGetters, mapActions  } from 'vuex'; // Map the Getters from the Vuex Store

export default {
    name: 'PassGenerator',
    data: () => ({
        form: {},
		formattedStartDate: "", // holds the formated version of the Project Start Date
		formattedEndDate: "", // holds the formated version of the Project End Date
		usersFromOrganisation: [],
    }),
    // * COMPUTED
    computed: {
        ...mapGetters({
			GET_openItem: "GET_openPass", // Get Open pass Data
        }),
		computedUsersfromOrganisations() {
			return this.usersFromOrganisation.map((item) => {
				return {
                    userId: item.userId,
					userName: `${item.userName} (${item.userStatus})`,
				};
			});
		},
    },
    methods: {
		...mapActions({ ACT_openItem: "ACT_openPass" }),
        // OPEN ITEM (GENERIC)
        openItem: async function() {
            var t = this;
            var openItem = await t.GET_openItem; // Get Open Item Data
            // console.log(" 1= " + JSON.stringify(openItem.data.data.id, null, 2))
            var item = await t.MIX_readDocumentById('passes', openItem.data.data.id)
            t.form = item.data; // Update the Form with the Open Item details 
            // console.log(" 2= " + JSON.stringify(t.form.startDate, null, 2))     
            t.formattedStartDate = t.MIX_formatDateTime(t.form.startDate, "x", "DD-MMM-YYYY"); // Update the Formatted Project Start Date
		    t.formattedEndDate = t.MIX_formatDateTime(t.form.endDate, "x", "DD-MMM-YYYY"); // Update the Formatted Project Start Date
            return;
        },
		// getUserDetails: function(userId) {
		// 	// console.log("getUserDetails Updated " + userId);
		// 	var t = this;
		// 	var user = t.$find(t.usersFromOrganisation, { userId: userId });
		// 	// console.log("user = " + user);
		// 	return user;
		// },
		getUserDetails: function(userId, field) {
			var t = this;
			var user = t.$find(t.usersFromOrganisation, { userId: userId });
            if ((user !== undefined) && (user !== null) && (user !== '')) {
                return user[field];
            } else {
                return '';
            }
		},          
		getUsersFromOrganisation: async function() {
			var t = this;
			//console.log("t.form.organisation = " + JSON.stringify(t.form.organisation, null, 2));
			var usersResult = await t.MIX_usersFromOrganisation(t.form.organisation.organisationId);
			if (usersResult.code === 1) {
				t.usersFromOrganisation = usersResult.data;
			} else {
				// console.log("ERROR OCCURED - " + usersResult.message + "\n" + usersResult.error);
				// do nothing
			}
		},
        closePass() {
            this.MIX_puDialog(false, '', '', '')
        },
        exportPass() {
            window.print();
        },
    },
    async mounted() {
        var t = this;
        await t.openItem()
		t.getUsersFromOrganisation();
    }
}
</script>

<style>
@media print {
  .noprint {
    display: none !important;
    clear: both !important;
  }
  .pass {
    width: 100vh !important;
    height: 100vh !important;
  }
}
</style>